/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_Caption_Editing_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Caption editing tools" |
*
* @param {Toolbar_Secondary_Caption_Editing_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_caption_editing_aria_label = /** @type {((inputs?: Toolbar_Secondary_Caption_Editing_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_Caption_Editing_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Outils d'édition de sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bildunterschriftenbearbeitungswerkzeuge")
	if (locale === "it") return /** @type {LocalizedString} */ ("Strumenti di modifica delle didascalie")
	if (locale === "ru") return /** @type {LocalizedString} */ ("инструменты редактирования субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Herramientas de edición de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕编辑工具")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプション編集ツール")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन संपादन उपकरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ferramentas de edição de legendas")
	return /** @type {LocalizedString} */ ("Caption editing tools")
});